"use client"
import "./ProductionBook.css"

const ProductionBook = () => {
  return (
    <section className="production-book-section">
      <div className="container">
      {/* Yellow strip that covers the bottom portion */}
      <div className="yellow-strip"></div>

      {/* Content container */}
      <div className="production-book-wrapper">
        <div className="production-book-content">
          <p className="production-book-description">
            Buy our published book on Product Design Process. Part of the curriculum in several universities across
            Portugal and Canada.
          </p>
         
        </div>

        {/* Book image positioned to span both white and yellow areas */}
        <div className="production-book-image-container">
          <img
            src="/book.svg?height=400&width=300"
            alt="Product Design Process Book"
            className="production-book-image"
          />
        </div>
      </div>
      </div>
    </section>
  )
}

export default ProductionBook
